"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATED_CITY = exports.EVENTS_TYPE = exports.EVENT_INTIALS = exports.EVENTS = void 0;
exports.EVENTS = {
    PAGE_LOADED: 'WtoC_PageLoaded',
    ENABLE_BACKDROP: 'WtoC_EnableBackdrop',
    DISABLE_BACKDROP: 'WtoC_DisabledBackdrop',
    RESIZE_HEIGHT: 'WtoC_ResizeHeight',
    WIDGET_LOADED: 'WtoC_WidgetLoaded',
    WIDGET_ERROR: 'WtoC_Error',
    SUBMIT: 'WtoC_Submitted',
    SAVED_ADDRESS: 'CtoW_SavedAddress',
    AUTO_FILL: 'CtoW_AutoFill',
    SEND_PROPS: 'CtoW_SendProps',
};
exports.EVENT_INTIALS = 'WtoC';
exports.EVENTS_TYPE = {
    AUTO_FILL: 'autoFill',
    PROPS: 'props',
};
exports.UPDATED_CITY = 'City not found with given pincode';
